<div class="modal-container">
  <div class="modal-header">
    <h3>{{ title() }}</h3>

    <button
      type="button"
      class="close-button"
      [attr.aria-label]="'GENERAL.CLOSE' | translate"
      (click)="onClose()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="results-count">{{ totalRecords() }} {{ title() }}s</div>

    <div class="results-grid-container">
      <lib-common-ag-grid
        [rowData]="rowData()"
        [colDefs]="colDefs()"
        [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions"
        [showColumnSettingsIcon]="false"
        [isLoadingTable]="isLoading()"
      >
      </lib-common-ag-grid>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="cancel-button"
      [attr.aria-label]="'GENERAL.CLOSE' | translate"
      (click)="onClose()"
    >
      {{ 'GENERAL.CLOSE' | translate | uppercase }}
    </button>
  </div>
</div>
